import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-db7d34d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container footer-inner" }
const _hoisted_2 = { class: "footer-column footer-brand" }
const _hoisted_3 = { class: "footer-brand__head" }
const _hoisted_4 = { class: "footer-brand__name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-brand__divider",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "footer-brand__tagline" }
const _hoisted_7 = { class: "footer-contact" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "footer-social" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = {
  class: "social-icon",
  href: "https://www.instagram.com",
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "Instagram"
}
const _hoisted_17 = { class: "footer-column" }
const _hoisted_18 = { class: "footer-title" }
const _hoisted_19 = { class: "footer-links" }
const _hoisted_20 = { class: "footer-bottom" }

import { watch, ref, onMounted, computed } from "vue";
import store from "@/store";
import commons from "@/utils/Common";
import { apiRedis } from "@/api/index";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  FacebookOutlined,
  InstagramOutlined,
  GoogleOutlined,
} from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultFooter',
  setup(__props) {

const { t, te } = useI18n();

const FOOTER_LABEL_KEYS: Record<string, string> = {
  "tài khoản": "text.account",
  "tai khoan": "text.account",
  "chăm sóc khách hàng": "text.customerSupport",
  "cham soc khach hang": "text.customerSupport",
  "đăng nhập": "text.login",
  "dang nhap": "text.login",
  "đăng ký": "text.register",
  "dang ky": "text.register",
  "giỏ hàng": "text.cart",
  "gio hang": "text.cart",
  "kiểm tra đơn hàng": "text.trackOrder",
  "kiem tra don hang": "text.trackOrder",
  "hướng dẫn mua hàng": "text.howToOrder",
  "huong dan mua hang": "text.howToOrder",
  "hướng dẫn thanh toán": "text.paymentGuide",
  "huong dan thanh toan": "text.paymentGuide",
  "phương thức thanh toán": "text.paymentMethods",
  "phuong thuc thanh toan": "text.paymentMethods",
  "chính sách đổi trả": "text.returnExchangePolicy",
  "chinh sach doi tra": "text.returnExchangePolicy",
  "hướng dẫn đổi trả": "text.returnGuide",
  "huong dan doi tra": "text.returnGuide",
  "hướng dẫn bảo hành": "text.warrantyGuide",
  "huong dan bao hanh": "text.warrantyGuide",
  "chính sách bảo hành": "text.warrantyPolicy",
  "chinh sach bao hanh": "text.warrantyPolicy",
  "chính sách giao hàng": "text.deliveryPolicy",
  "chinh sach giao hang": "text.deliveryPolicy",
  "câu hỏi thường gặp": "text.faq",
  "cau hoi thuong gap": "text.faq",
  "giới thiệu": "text.aboutUs",
  "gioi thieu": "text.aboutUs",
  "về kima home": "text.aboutKimaHome",
  "ve kima home": "text.aboutKimaHome",
  "hệ thống cửa hàng": "text.storeLocations",
  "he thong cua hang": "text.storeLocations",
  "khuyến mại": "text.promotions",
  "khuyen mai": "text.promotions",
  "tuyển dụng": "text.careers",
  "tuyen dung": "text.careers",
  "liên hệ": "text.contact",
  "lien he": "text.contact",
  "cam kết sản phẩm chính hãng": "text.authenticCommitment",
  "cam ket san pham chinh hang": "text.authenticCommitment",
  "chính sách bảo mật": "text.privacyPolicyTitle",
  "chinh sach bao mat": "text.privacyPolicyTitle",
  "sản phẩm": "text.products",
  "san pham": "text.products",
  "bộ sưu tập": "text.collections",
  "bo suu tap": "text.collections",
  "trang chủ": "text.home",
  "trang chu": "text.home",
  "đơn hàng": "text.allOrders",
  "don hang": "text.allOrders",
};

const normalizeLabel = (label: string) => label.trim().toLowerCase();

const translateLabel = (label?: string) => {
  if (!label) return "";
  if (label.includes(".")) {
    return te(label) ? t(label) : label;
  }
  const key = FOOTER_LABEL_KEYS[normalizeLabel(label)];
  return key ? t(key) : label;
};

const companys = ref({
  summary: "",
  sub_name: "",
  address: "",
  phone: "",
  name: "",
  description: "",
  logo: "",
  id: null as number | null,
  email: "",
});

const brandName = computed(() => {
  const raw =
    companys.value.sub_name || companys.value.name || "KIMAHOME";
  return String(raw).toUpperCase();
});

const brandTagline = computed(() => {
  const s = (companys.value.summary || "").trim();
  if (s && s.length <= 40) return s.toUpperCase();
  return t("text.luxuryFurniture").toUpperCase();
});

const menuFooter = ref<any[]>([]);

onMounted(() => {
  loadMenuFooter();
  cokiesCompany();
});

const cokiesCompany = () => {
  const data = commons.getCokiesCompany();
  if (data) companys.value = data;
};

const isLCompanyInfor = computed(() => store.getters.isLCompanyInfor);
watch(isLCompanyInfor, () => {
  cokiesCompany();
});

const loadMenuFooter = async () => {
  await apiRedis("default-fotter").then((res) => {
    const response: any = res;
    let data = response.data.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
    menuFooter.value = data || [];
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { class: "footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, {
          gutter: [32, 40],
          class: "footer-main"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              sm: 12,
              md: 6,
              lg: 6
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(brandName.value), 1),
                    _hoisted_5,
                    _createElementVNode("p", _hoisted_6, _toDisplayString(brandTagline.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (companys.value.address)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createVNode(_unref(EnvironmentOutlined)),
                          _createElementVNode("span", null, _toDisplayString(companys.value.address), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (companys.value.phone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                          _createVNode(_unref(PhoneOutlined)),
                          _createElementVNode("a", {
                            href: `tel:${companys.value.phone}`
                          }, _toDisplayString(companys.value.phone), 9, _hoisted_10)
                        ]))
                      : _createCommentVNode("", true),
                    (companys.value.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          _createVNode(_unref(MailOutlined)),
                          _createElementVNode("a", {
                            href: `mailto:${companys.value.email}`
                          }, _toDisplayString(companys.value.email), 9, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("a", {
                      class: "social-icon",
                      href: "https://www.facebook.com",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": _ctx.$t('text.facebook')
                    }, [
                      _createVNode(_unref(FacebookOutlined))
                    ], 8, _hoisted_14),
                    _createElementVNode("a", {
                      class: "social-icon",
                      href: "https://www.google.com",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": _ctx.$t('text.google')
                    }, [
                      _createVNode(_unref(GoogleOutlined))
                    ], 8, _hoisted_15),
                    _createElementVNode("a", _hoisted_16, [
                      _createVNode(_unref(InstagramOutlined))
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuFooter.value, (menu, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: index,
                xs: 24,
                sm: 12,
                md: 6,
                lg: 6
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h4", _hoisted_18, _toDisplayString(translateLabel(menu.linkLabel)), 1),
                    _createElementVNode("ul", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child, cindex) => {
                        return (_openBlock(), _createElementBlock("li", { key: cindex }, [
                          _createVNode(_component_router_link, {
                            to: child.linkTo || '/'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(translateLabel(child.linkLabel)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("text.copyright")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})